<template>
	<div @click="handleClick">
		<div class="relative flex w-full items-center gap-x-3">
			<div v-if="option.icon" class="flex h-full items-center justify-center">
				<Component
					:is="option.icon?.component"
					v-bind="option.icon?.bindings"
				/>
			</div>
			<div class="flex w-full items-center gap-4">
				<template v-if="typeof option.label === 'string'">
					<span class="font-sans text-sm font-normal leading-normal text-white">
						{{ option.label }}
					</span>
				</template>
				<Component :is="option.label" v-else />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { handleEventProps } from '~/composables/events/headerEvents';
import { useEvents } from '~/composables/events/useEvents';

import { type NavDefaultOptionConfig } from '.';

const { trackHeader } = useEvents();

const handleClick = () =>
	handleEventProps(
		props.option.eventProps,
		trackHeader.handleEventMenuHeaderClick
	);

const props = defineProps<{
	option: NavDefaultOptionConfig;
}>();
</script>
